module.exports = __webpack_public_path__ + "static/media/p1_face.1e924cf3.png";